module.exports = __webpack_public_path__ + "f8e171dcc4fb260d6c172de7644fd9ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Banner/components/Background/images/smallWave.svg
// module id = 9PYj
// module chunks = 13